import React, { useState } from "react";
import { AHSeparator, Dialog, FilterButton, ListItem } from "arkh";
import { DayFilter } from "./filter";
import { FormattedMessage } from "react-intl";
import { useWeekdays } from "../../common/useWeekdays";
import { useIntlTokens } from "../../components/mobile/useIntlTokens";
import { onPressInHaptic } from "widgets/src/onPressInHaptic";
import { ScrollView } from "react-native";

export function FilterButtonWeekday(props: {
  selectedDays: DayFilter;
  setSelectedDays: (days: DayFilter) => void;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const intlTokens = useIntlTokens();
  const weekdaysLong = useWeekdays("long");
  const weekdaysShort = useWeekdays("short");

  const options: { value: DayFilter; label: string; dialogLabel: string }[] = [
    {
      value: "weekday",
      label: intlTokens.Weekdays_excluding_weekend,
      dialogLabel: intlTokens.Weekdays_excluding_weekend,
    },
    {
      value: "weekend",
      label: intlTokens.Weekends,
      dialogLabel: intlTokens.Weekends,
    },
    ...weekdaysLong.map((longName, i) => ({
      value: i as DayFilter,
      label: weekdaysShort[i],
      dialogLabel: longName,
    })),
  ];

  const isActive = props.selectedDays !== "all";
  const selectedOption = options.find((o) => o.value === props.selectedDays);

  const onSelect = (value: DayFilter) => {
    onPressInHaptic();
    if (props.selectedDays === value) {
      props.setSelectedDays("all");
    } else {
      props.setSelectedDays(value);
    }
  };

  const label = isActive ? (
    selectedOption?.label
  ) : (
    <FormattedMessage
      defaultMessage="Weekday"
      description="TeamScheduleAdmin filter button label for weekday filter"
    />
  );

  return (
    <>
      {isActive ? (
        <FilterButton
          mode="active"
          isPlural={true}
          indicatorIcon="calendar"
          onPress={() => setIsOpen(true)}
        >
          {label}
        </FilterButton>
      ) : (
        <FilterButton
          mode="inactive"
          indicatorIcon="calendar"
          onPress={() => setIsOpen(true)}
        >
          {label}
        </FilterButton>
      )}
      <Dialog
        visible={isOpen}
        onClose={() => setIsOpen(false)}
        title={
          <FormattedMessage
            defaultMessage="Weekday"
            description="TeamScheduleAdmin weekday filter dialog title"
          />
        }
      >
        <ScrollView style={{ flex: 1 }}>
          {options.map((option, index) => {
            const selected = props.selectedDays === option.value;
            return (
              <React.Fragment key={String(option.value)}>
                {index > 0 ? <AHSeparator /> : null}
                <ListItem
                  right={<ListItem.SelectIndicator selected={selected} />}
                  onPress={() => onSelect(option.value)}
                >
                  <ListItem.Title
                    color={selected ? "text-primary" : "text-secondary"}
                  >
                    {option.dialogLabel}
                  </ListItem.Title>
                </ListItem>
              </React.Fragment>
            );
          })}
        </ScrollView>
      </Dialog>
    </>
  );
}
